import React, { useState, useEffect } from 'react';
import Title from '../../components/common/Title';
import { useTranslation } from 'react-i18next';
import Screen from '../../components/common/Screen';
import Button from '../../components/elements/Button';
import Icon from '../../components/common/Icon';
import Left from '../../components/css/Left';
import { useNavigate } from 'react-router-dom';
import InputField from '../../components/forms/InputField';
import { fetchUserInfo, teamPhoto } from '../../utils';
import Card from '../../components/elements/Card';
import Image from '../../components/images/Image';
import { apiRequest } from '../../utils';
import Toast from '../../components/forms/Toast';


const Page = () => {
  const { t } = useTranslation();
  const [userInfo, setUserInfo] = useState(null);
  const [, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [showToast, setShowToast] = useState(false);

  const [searchQuery, setSearchQuery] = useState('');
  const [isSubmittingClaim, setIsSubmittingClaim] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    // same pattern as add-players
    fetchUserInfo('/claim-a-team', setUserInfo, setLoading, setError, []);
  }, []);

  const handleSearchChange = (e) => {
    setSearchQuery(e.target.value.toLowerCase());
  };

const claimTeam = async (teamId, teamName) => {
  if (isSubmittingClaim) return;
  const confirmed = window.confirm(
    t('confirmClaimTeamMessage', { teamName: teamName || t('team') })
  );
  if (!confirmed) return;

  setIsSubmittingClaim(true);
  try {
    await apiRequest(
      'POST',
      '/claim-a-team',
      { teamId },
      {}
    );

    sessionStorage.setItem('otherTeamId', teamId);
    navigate('/home');
  } catch (error) {
    console.error(error.message);
    setError(error.message);
    setShowToast(true);
  } finally {
    setIsSubmittingClaim(false);
  }
};


  const unclaimedTeams = userInfo?.unclaimed|| [];
  const claimedTeams = userInfo?.claimed || [];

  const filteredUnclaimed = unclaimedTeams.filter((team) =>
    (team.name || '').toLowerCase().includes(searchQuery)
  );

  const filteredClaimed = claimedTeams.filter((team) =>
    (team.name || '').toLowerCase().includes(searchQuery)
  );

  return (
    <Screen p="3">
      <div className="top">
        <Title>{t('claimATeam')}</Title>

        {(unclaimedTeams.length > 0 || claimedTeams.length > 0) && (
          <div className="justify-content-center">
            <div className="row align-items-center">
              <div className="col-1" style={{ marginTop: '-0.7rem' }}>
                <Icon name="search" />
              </div>

              <div className="col-11">
                <InputField
                  placeholder={t('searchTeams')}
                  name="searchTeams"
                  value={searchQuery}
                  onChange={handleSearchChange}
                >
                  <Icon name="users" />
                </InputField>
              </div>
            </div>
          </div>
        )}

        {/* UNCLAIMED */}
        {userInfo && filteredUnclaimed.length > 0 && (
          <div className="justify-content-center">
            <hr className="mb-2" />
            <Left>
              <Title heading="6" my="2" className="mt-2">
                {t('unclaimedTeams')} {userInfo && <>({filteredUnclaimed.length})</>}
              </Title>
            </Left>

            {filteredUnclaimed.map((team) => (
              <div className="dropdown" key={team.id}>
                <Button
                  p="1"
                  mb="1"
                  theme="light"
                  dataBsToggle="dropdown"
                  ariaExpanded={false}
                >
                  <div className="row">

                    <div className="col-2 d-flex align-items-center">
                        <Image
                            url={teamPhoto(team.photo_url, team.company_picture)}
                            size="3rem"
                            className="circle mb-1"
                            reload={true}
                        />
                    </div>
                    <div className="col-9 d-flex align-items-center">
                      <Left>
                        <b>{team.name}</b>
                      </Left>
                    </div>

                    <div className="col-1 d-flex align-items-center">
                      <Icon
                        name="menu-dots-vertical"
                        theme="secondary"
                        style={{ marginLeft: '-0.8rem' }}
                      />
                    </div>
                  </div>
                </Button>

                <ul className="dropdown-menu dropdown-menu-end">
                  <li>
                    <button
                      type="button"
                      className="dropdown-item"
                      onClick={() => claimTeam(team.id, team.name)}
                    >
                      <Icon
                        name="user-check"
                        className="me-1"
                        theme="primary"
                      />
                      {t('claimTeam')}
                    </button>
                  </li>
                </ul>
              </div>
            ))}
          </div>
        )}

        {/* CLAIMED (NO OPTIONS) */}
        {userInfo && filteredClaimed.length > 0 && (
          <div className="justify-content-center">
            <hr className="mb-2" />
            <Left>
              <Title heading="6" my="2" className="mt-2">
                {t('claimedTeams')} {userInfo && <>({filteredClaimed.length})</>}
              </Title>
            </Left>

            {filteredClaimed.map((team) => (
              <div key={team.id}>
                <Button p="1" mb="1" theme="light" disabled>
                  <div className="row">
                    <div className="col-2 d-flex align-items-center">
                        <Image
                            url={teamPhoto(team.photo_url, team.company_picture)}
                            size="3rem"
                            className="circle mb-1"
                            reload={true}
                        />
                    </div>
                    <div className="col-10 d-flex align-items-center">
                      <Left>
                        <b>{team.name}</b>
                      </Left>
                    </div>
                  </div>
                </Button>
              </div>
            ))}
          </div>
        )}

        {/* Empty state */}
        {userInfo && unclaimedTeams.length === 0 && claimedTeams.length === 0 && (
          <div className="justify-content-center mt-3">
            <Card p="3">
              <Title heading="6">{t('noTeamsToClaim')}</Title>
            </Card>
          </div>
        )}

        <Toast showToast={showToast} setShowToast={setShowToast} message={t(error)} />
      </div>
    </Screen>
  );
};

export default Page;
